export const CHANGE_DATA_SHOPPING_CART = "CHANGE_DATA_SHOPPING_CART";
export const ADD_ITEM_IN_SHOPPING_CART = "ADD_ITEM_IN_SHOPPING_CART";
export const CHANGE_API_CARTS_LIST_PRODUCTS_MODAL_SHOPPING_CARD = "CHANGE_API_CARTS_LIST_PRODUCTS_MODAL_SHOPPING_CARD";
export const REMOVE_ALL_ITEM_IN_BASKET_CART = "REMOVE_ALL_ITEM_IN_BASKET_CART";
export const REMOVE_ITEM_IN_BASKET_CART = "REMOVE_ITEM_IN_BASKET_CART";
export const REFRESH_MODAL_SHOPPING_CARD = "REFRESH_MODAL_SHOPPING_CARD";
